// AdminDashboard.js
import { useAuth } from 'components/ui/navigationGuard';
import useAdminDashboardLogic from 'hooks/useDashboard';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AdminNavigation from '../../layouts/adminNavigation';
import AttendanceChart from './components/attendanceChart';
import AttendanceTable from './components/attendanceTable';
import MetricCard from './components/metricCard';

const AdminDashboard = () => {
  const { user, loading, isAuthenticated } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { employees, total_count, last_31_days_count, error } = useSelector((state) => state.employees);
  
  // Use the custom hook to get all the state and functions
  const {
    currentTime,
    isLoading,
    dashboardSummary,
    strangers,
    attendanceRecords,
    filteredRecords,
    summary,
    stats,
    fetchAttendance,
    formatDateTime
  } = useAdminDashboardLogic();

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const metrics = [
    {
      title: "Total Employees",
      value: dashboardSummary.total_employees || "0",
      icon: "Users",
      iconColor: "text-primary"
    },
    {
      title: "Total Stranger",
      value: dashboardSummary.total_unkown || "0",
      icon: "Users",
      iconColor: "text-primary"
    },
    {
      title: "Last 31 Days Employees",
      value: dashboardSummary.last_31_days_employees || "0",
      icon: "Users",
      iconColor: "text-primary"
    },
    // {
    //   title: "Total Present",
    //   value: summary?.total_present || "0",
    //   icon: "Users",
    //   iconColor: "text-primary"
    // },
    // {
    //   title: "Total Detection",
    //   value: stats?.totalDetections || "0",
    //   icon: "Users",
    //   iconColor: "text-primary"
    // },
    // {
    //   title: "Today's Detection",
    //   value: stats?.newToday || "0",
    //   icon: "Users",
    //   iconColor: "text-primary"
    // },
    {
      title: "Today's Attendance",
      value: dashboardSummary.today_attendance_percentage ? `${dashboardSummary.today_attendance_percentage}%` : "0%",
      icon: "UserCheck",
      iconColor: "text-success"
    },
    // {
    //   title: "Recent Alerts",
    //   value: dashboardSummary.recent_alerts || "0",
    //   icon: "AlertTriangle",
    //   iconColor: "text-error"
    // }
  ];

  return (
    <div className="min-h-screen bg-background">
      <AdminNavigation
        user={user}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />
      {/* Main Content */}
      <main className={`pt-16 transition-all duration-200 ease-in-out ${isCollapsed ? 'lg:pl-16' : 'lg:pl-64'
        }`}>
        <div className="p-6 space-y-6">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
            <div>
              <h1 className="text-2xl font-semibold text-foreground">Admin Dashboard</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Monitor attendance, manage employees, and oversee system operations
              </p>
            </div>
            <div className="flex flex-col sm:items-end">
              <div className="text-sm font-medium text-foreground">
                {formatDateTime(currentTime)}
              </div>
            </div>
          </div>

          {/* Key Performance Indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {metrics?.map((metric, index) => (
              <MetricCard
                key={index}
                title={metric?.title}
                value={metric?.value}
                icon={metric?.icon}
                iconColor={metric?.iconColor}
              />
            ))}
          </div>

          {/* Charts Section */}
          <AttendanceChart />

          {/* Attendance Records Table */}
          <AttendanceTable />

          {/* Quick Actions */}
          {/* <QuickActions /> */}

        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;